import { useEffect } from "react";
import styled from "styled-components";
import GradientBg from "../components/home/GradientBg";
import HomeHero from "../components/home/HomeHero";
import FeatureCards from "../components/home/FeatureCards";
import PrayerTimes from "../components/home/PrayerTimes";

export default function HomePage() {
  // Next's `export const metadata` → set title imperatively
  useEffect(() => {
    document.title = "نور على نور";
  }, []);

  return (
    <GradientBg>
      <Container>
        <HomeHero />
        <FeatureCards />
        <PrayerTimes />
      </Container>
    </GradientBg>
  );
}

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 48px) clamp(16px, 3vw, 24px);
`;
